var $575e5f7a9815f571$exports = {};
$575e5f7a9815f571$exports = {
    "valid": `V\xe1lido`
};


export {$575e5f7a9815f571$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
